import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'Marcos R.',
  city: 'Buenos Aires',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 2 min'
}, {
  name: 'Diego P.',
  city: 'Córdoba',
  product: 'Megapack Artes Marciales',
  time: 'hace 5 min'
}, {
  name: 'Federico S.',
  city: 'Rosario',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 8 min'
}, {
  name: 'Lucas M.',
  city: 'Mendoza',
  product: 'Megapack Artes Marciales',
  time: 'hace 12 min'
}, {
  name: 'Alejandro G.',
  city: 'Tucumán',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 15 min'
}, {
  name: 'Nicolás B.',
  city: 'Santa Fe',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 18 min'
}, {
  name: 'Pablo L.',
  city: 'La Plata',
  product: 'Megapack Artes Marciales',
  time: 'hace 22 min'
}, {
  name: 'Sebastián V.',
  city: 'Mar del Plata',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 25 min'
}, {
  name: 'Matías C.',
  city: 'Salta',
  product: 'Megapack Artes Marciales',
  time: 'hace 30 min'
}, {
  name: 'Gastón H.',
  city: 'Neuquén',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 35 min'
}, {
  name: 'Rodrigo F.',
  city: 'San Juan',
  product: 'Megapack Artes Marciales',
  time: 'hace 40 min'
}, {
  name: 'Ezequiel K.',
  city: 'Paraná',
  product: 'Megapack Artes Marciales + Academia Online™',
  time: 'hace 45 min'
}];
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    const initialTimeout = setTimeout(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 6000);
    const interval = setInterval(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 12000 + Math.random() * 6000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  return <div className="fixed bottom-4 left-4 z-50" style={{
    maxWidth: 'calc(100vw - 32px)'
  }} data-id="element-254">
      <AnimatePresence data-id="element-255">
        {visible && purchase && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="flex items-center gap-3 border rounded-xl px-4 py-3 shadow-lg max-w-sm" style={{
        backgroundColor: 'rgb(20, 5, 5)',
        borderColor: 'rgb(127, 29, 29)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }} data-id="element-256">
            {/* AVATAR */}
            <div className="flex h-9 w-9 shrink-0 items-center justify-center bg-red-950 text-red-500 rounded-full text-sm font-black" data-id="element-257">
              🥋
            </div>

            {/* INFO */}
            <div className="min-w-0 flex-1" data-id="element-258">
              <p className="text-xs font-bold text-white m-0 truncate" data-id="element-259">
                {purchase.name} de {purchase.city}
              </p>
              <p className="text-[10px] text-gray-400 m-0 truncate" data-id="element-260">
                acaba de comprar{' '}
                <span className="font-semibold text-red-500" data-id="element-261">
                  {purchase.product}
                </span>
              </p>
              <p className="text-[9px] text-gray-600 m-0 mt-0.5" data-id="element-262">
                🕐 {purchase.time}
              </p>
            </div>

            {/* BADGE VERIFICADO */}
            <div className="shrink-0" data-id="element-263">
              <span className="text-[9px] font-bold text-green-400 bg-green-950 border border-green-900 rounded-full px-1.5 py-0.5" data-id="element-264">
                ✓ Verificado
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}